<script setup>
import UnassignedClaimsComponent from "@/Components/Claims/UnassignedClaimsComponent.vue";
import MessagesAdjusterComponent from "@/Components/Messaging/MessagesAdjusterComponent.vue";
import BulkAssignComponent from "@/Components/Claims/BulkAssignComponent.vue";
import {Permissions} from "@/Utils/Permissions";
</script>

<template>
  <v-row v-if="Permissions.checkPermissions(['messaging.list'])">
    <v-col cols="12">
      <MessagesAdjusterComponent/>
    </v-col>
  </v-row>
  <v-row v-if="Permissions.checkPermissions(['claims.unassigned'])">
    <v-col cols="12">
      <UnassignedClaimsComponent />
    </v-col>
  </v-row>
  <v-row v-if="Permissions.checkPermissions(['claims.bulk-assign'])">
    <v-col cols="12">
      <BulkAssignComponent/>
    </v-col>
  </v-row>
</template>